import { get, post, serialize } from '../httpClient';

export const reviewsAPI = {
  query: params => get('/api/reviews/query', params),
  send: body => post('/api/reviews/send', serialize(body)),
  addLike: body => post('/api/reviews/add-like', serialize(body)),
  addDislike: body => post('/api/reviews/add-dislike', serialize(body)),
};